export default {
  name: 'input_date',
  component_path: 'modules/procedures/blocks/BlockInputDate',
  static_options: {
    format: 'yyyy/MM/dd HH:mm:ss',
    open_date: new Date()
  }
}